import { call, put } from "redux-saga/effects";
import { REHYDRATE } from "redux-persist/constants";
import authModule from "./AuthModule";
import api from "services/api";

import { createModule, constants } from "./redux-acron";

/**
 * User Module
 * reducer/sagas/actions
 */
export default createModule({
  name: "appusers",
  modelName: "appusers",
  state: {
    loading: false,
    list: null,
    page: 0,
    limit: 15,
    sort: "createdDate,desc",
    filters: {
      rol: undefined,
      nameMatch: "",
      loginMatch: ""
    },

    loadingForm: false,
    formSubmited: false,
    formError: false,
    errorMessage: false,
    formValues: {},

    loadingDetail: false,
    detail: null,

    loadingFormData: false,
    formData: {},

    loadingDelete: false,
    deleted: null
  },
  handlers: {
    getList: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loading: true,
          list: payload.page === 0 ? [] : state.list,
          page: payload.page,
          limit: payload.limit,
          sort: payload.sort,
          filters: payload.filters
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loading: false,
          list: payload.data,
          total: payload.total,
          sort: payload.sort,
          filters: payload.filters
        });
      }

      return state;
    },

    getDetail: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loadingDetail: true,
          detail: null
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loadingDetail: false,
          detail: payload.data
        });
      }

      return state;
    },

    create: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loadingForm: true,
          formSubmited: false,
          formError: false,
          errorMessage: "",
          formValues: payload.data
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loadingForm: false,
          formSubmited: payload.id,
          formError: false,
          errorMessage: "",
          formValues: {}
        });
      }

      if (status === constants.FAILURE_STATUS) {
        return state.merge({
          loadingForm: false,
          formError: true,
          errorMessage: payload.message
        });
      }
    },

    update: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loadingForm: true,
          formSubmited: false
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loadingForm: false,
          formSubmited: payload.id
        });
      }

      if (status === constants.FAILURE_STATUS) {
        return state.merge({
          loadingForm: false,
          formError: true,
          errorMessage: payload.message
        });
      }
    },

    getFormData: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loadingFormData: true,
          formData: {}
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loadingFormData: false,
          formData: payload.data
        });
      }
    },

    deleteUser: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loadingDelete: true,
          deleted: null
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        let list = state.list;
        if (list) {
          list = list.filter(user => user.id !== payload.id);
        }

        return state.merge({
          loadingDelete: false,
          deleted: payload.id,
          list: list
        });
      }

      if (status === constants.FAILURE_STATUS) {
        return state.merge({
          loadingDelete: false,
          deleted: null
        });
      }

      return state;
    }
  },
  effects: {
    getList: {
      *callback(actions, { payload }) {
        const response = yield call(
          api.appusers.list,
          payload.page,
          payload.limit,
          payload.filters,
          payload.sort
        );

        if (response.ok) {
          yield put(
            actions.getList(
              {
                page: payload.page,
                data: response.data,
                total: parseInt(response.headers["x-total-count"]),
                sort: payload.sort,
                filters: payload.filters
              },
              constants.SUCCESS_STATUS
            )
          );
        } else {
          yield put(actions.getList({}, constants.FAILURE_STATUS));
        }
      }
    },

    create: {
      *callback(actions, { payload }) {
        const response = yield call(api.appusers.create, payload.data);

        if (response.ok) {
          yield put(
            actions.create(
              {
                id: response.data.id
              },
              constants.SUCCESS_STATUS
            )
          );
        } else {
          yield put(
            actions.create(
              {
                message: response.fieldErrors
                  ? "Ha ocurrido un error"
                  : response.data.description
              },
              constants.FAILURE_STATUS
            )
          );
        }
      }
    },

    update: {
      *callback(actions, { payload }) {
        const response = yield call(api.appusers.update, payload.data);

        if (response.ok) {
          yield put(
            actions.update(
              {
                id: response.data.id
              },
              constants.SUCCESS_STATUS
            )
          );
        } else {
          yield put(
            actions.update(
              {
                message: response.fieldErrors
                  ? "Ha ocurrido un error"
                  : response.data.description
              },
              constants.FAILURE_STATUS
            )
          );
        }
      }
    },

    getDetail: {
      *callback(actions, { payload }) {
        const response = yield call(api.appusers.detail, payload.id);

        if (response.ok) {
          yield put(
            actions.getDetail(
              {
                data: response.data
              },
              constants.SUCCESS_STATUS
            )
          );
        } else {
          yield put(actions.getDetail({}, constants.FAILURE_STATUS));
        }
      }
    },

    getFormData: {
      *callback(actions, { payload }) {
        const response = yield call(api.appusers.list, 0, 100000, {}, false);

        if (response.ok) {
          yield put(
            actions.getFormData(
              {
                data: {
                  users: response.data
                }
              },
              constants.SUCCESS_STATUS
            )
          );
        } else {
          yield put(actions.getFormData({}, constants.FAILURE_STATUS));
        }
      }
    },

    deleteUser: {
      *callback(actions, { payload }) {
        let response = {};
        if (payload.newManager) {
          response = yield call(
            api.appusers.assign,
            payload.id,
            payload.newManager
          );
        }

        if (response.ok || !payload.newManager) {
          const deleteResponse = yield call(api.appusers.delete, payload.id);

          if (deleteResponse.ok) {
            yield put(
              actions.deleteUser({ id: payload.id }, constants.SUCCESS_STATUS)
            );
          }
        } else {
          yield put(actions.deleteUser({}, constants.FAILURE_STATUS));
        }
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/AppUsersModule.js